var map = {
	"./年产值.png": "./src/assets/images/index/nav/cyzl/年产值.png",
	"./年产量.png": "./src/assets/images/index/nav/cyzl/年产量.png",
	"./种植基地.png": "./src/assets/images/index/nav/cyzl/种植基地.png",
	"./种植面积.png": "./src/assets/images/index/nav/cyzl/种植面积.png",
	"./荔枝品种.png": "./src/assets/images/index/nav/cyzl/荔枝品种.png",
	"./销售收入.png": "./src/assets/images/index/nav/cyzl/销售收入.png",
	"./鲜果收入.png": "./src/assets/images/index/nav/cyzl/鲜果收入.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/index/nav/cyzl sync recursive ^\\.\\/.*\\.png$";